<template>
  <div class="contents_wrapper" v-if="isVisible">
    <div class='contents'>
      <p class="large_white_label">ようこそ{{user.displayName}}さん</p>
      <MypageButtonBlock/>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from "vuex";
  import MypageTop from "@/assets/js/pages/mypage/MypageTop";
  import MypageButtonBlock from "@/components/objects/block/mypage/MypageButtonBlock";
  import collection from "@/assets/js/functions/firebase/firestore/collection";

  export default {
    name: "MypageTop",

    components: {MypageButtonBlock},

    mixins: [collection, MypageTop],

    data() {
      return {
        isVisible: false
      }
    },

    computed: {
      ...mapGetters({user: 'auth/user', customClaim: 'auth/customClaim', uid: 'auth/uid'}),
    },

    async created() {
      if (!this.customClaim.hasUserDetail) {
        this.$router.push({name: 'RegistrationUserDetail'});
      }
      this.isVisible = true;
    },
  }
</script>

<style lang="scss" scoped>
  .contents_wrapper {
    background: linear-gradient(45deg, $client_third, $client_third, $operator_secondary, $operator_secondary);

    > .contents {
      @include contents();

      .large_white_label {
        width: 65%;
      }

      > .mypage-button_block {
        width: 70%;
      }
    }
  }
</style>